// Remove .00 from price
(function () {
  function init() {
    try {
      function updatePrices() {
        try {
          const priceElements = document.querySelectorAll(".gp-price");
          if (!priceElements || priceElements.length === 0) return;

          priceElements.forEach((element) => {
            try {
              if (
                element &&
                element.innerHTML &&
                element.innerHTML.includes(".00")
              ) {
                let price = element.innerHTML;
                price = price.replace(".00", "");
                element.innerHTML = price;
              }
            } catch (elementError) {
              console.log("Error updating individual price:", elementError);
            }
          });
        } catch (updateError) {
          console.log("Error in updatePrices:", updateError);
        }
      }

      // Initial update with delay
      setTimeout(updatePrices, 500);

      // Observer for dynamic content
      try {
        const observer = new MutationObserver(function (mutations) {
          setTimeout(updatePrices, 100);
        });

        // Start observing with a longer delay
        setTimeout(function () {
          observer.observe(document.body, {
            childList: true,
            subtree: true,
          });
        }, 1000);
      } catch (observerError) {
        console.log("Error setting up observer:", observerError);
      }
    } catch (initError) {
      console.log("Error in init function:", initError);
    }
  }

  // Run when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
